module.exports = __webpack_public_path__ + "img/x-square-fill.0b4c60ef.svg";